// extracted by mini-css-extract-plugin
export default {"wrapper":"PlaceOption_wrapper__4rWwW","titlePanel":"PlaceOption_titlePanel__++NAK","title":"PlaceOption_title__rHXSc","itemContainer":"PlaceOption_itemContainer__PUHWr"};